/**
 * Video Mute/Unmute Controls
 * Adds a mute/unmute button to HTML5 videos in the theme
 */

class VideoControls {
  constructor() {
    this.init();
  }

  init() {
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupControls());
    } else {
      this.setupControls();
    }
    
    // Re-apply controls after a delay (for dynamically loaded content)
    setTimeout(() => this.setupControls(), 1000);
    
    // Watch for new videos
    this.observeNewVideos();
  }

  setupControls() {
    // Process HTML videos only
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
      if (!video.closest('.video-with-controls')) {
        this.addControlsToVideo(video);
      }
    });
  }

  addControlsToVideo(video) {
    // Create wrapper if needed
    const parent = video.parentElement;
    let wrapper;
    
    if (parent.classList.contains('video-container') || 
        parent.classList.contains('local-video') || 
        parent.classList.contains('bls__video-thumb')) {
      wrapper = parent;
      wrapper.classList.add('video-with-controls');
    } else {
      // Create new wrapper
      wrapper = document.createElement('div');
      wrapper.classList.add('video-with-controls');
      wrapper.style.position = 'relative';
      
      // Insert wrapper before video
      parent.insertBefore(wrapper, video);
      
      // Move video inside wrapper
      wrapper.appendChild(video);
    }
    
    // Add mute button
    this.addMuteToggle(wrapper, video);
  }

  addMuteToggle(container, mediaElement) {
    // Skip if button already exists
    if (container.querySelector('.video-mute-toggle')) {
      return;
    }
    
    // Mark container as processed
    container.classList.add('video-with-controls');
    
    // Ensure container has position relative
    const containerStyle = window.getComputedStyle(container);
    if (containerStyle.position === 'static') {
      container.style.position = 'relative';
    }
    
    // Create button
    const button = document.createElement('button');
    button.className = 'video-mute-toggle is-muted';
    button.setAttribute('aria-label', 'Toggle sound');
    button.innerHTML = `
      <svg class="icon-mute" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M23 9L17 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17 9L23 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="icon-unmute" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.54 8.46C16.4774 9.39764 17.004 10.6692 17.004 11.995C17.004 13.3208 16.4774 14.5924 15.54 15.53" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.07 5.93C20.9447 7.80528 21.9979 10.3478 21.9979 13C21.9979 15.6522 20.9447 18.1947 19.07 20.07" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    
    // Add button to container
    container.appendChild(button);
    
    // Handle click events for HTML5 videos
    button.addEventListener('click', () => {
      mediaElement.muted = !mediaElement.muted;
      button.classList.toggle('is-muted', mediaElement.muted);
    });
  }

  observeNewVideos() {
    const observer = new MutationObserver(mutations => {
      let shouldProcess = false;
      
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          shouldProcess = true;
        }
      });
      
      if (shouldProcess) {
        setTimeout(() => this.setupControls(), 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

// Initialize on load
const videoControls = new VideoControls();
